export default "__VITE_ASSET__JjETqnQR__"